import React, { useEffect } from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const FinancialPlanning = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--service-bg-image',
      "url('https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=2070&auto=format&fit=crop')"
    );
    return () => {
      document.documentElement.style.removeProperty('--service-bg-image');
    };
  }, []);
  const benefits = [
    {
      title: 'Optimized Cash Flow',
      description: 'Improve cash flow management to ensure your business has the resources it needs to grow and thrive.'
    },
    {
      title: 'Better Decision Making',
      description: 'Make informed financial decisions based on accurate data analysis and professional insights.'
    },
    {
      title: 'Risk Management',
      description: 'Identify and mitigate financial risks to protect your business assets and ensure stability.'
    },
    {
      title: 'Increased Profitability',
      description: 'Implement strategies to maximize profitability and achieve sustainable financial growth.'
    }
  ];

  const features = [
    'Comprehensive financial analysis and reporting',
    'Budget planning and forecasting',
    'Investment strategy development',
    'Cost reduction and optimization',
    'Financial risk assessment and management',
    'Capital structure planning',
    'Financial modeling and scenario planning',
    'Profitability analysis and improvement',
    'Tax planning and optimization strategies'
  ];

  const process = [
    {
      title: 'Financial Assessment',
      description: 'Conduct a thorough review of your current financial situation, including analysis of statements, cash flow, and financial health.'
    },
    {
      title: 'Goal Setting',
      description: 'Work with you to define clear financial objectives and establish measurable targets for your business.'
    },
    {
      title: 'Strategy Development',
      description: 'Create customized financial strategies and action plans aligned with your business goals and market conditions.'
    },
    {
      title: 'Implementation',
      description: 'Execute the financial plan with ongoing support, monitoring, and adjustments as needed.'
    },
    {
      title: 'Performance Review',
      description: 'Regular reviews and reporting to track progress, identify opportunities, and ensure financial objectives are being met.'
    }
  ];

  return (
    <ServiceTemplate
      icon="📊"
      title="Financial Planning"
      subtitle="Comprehensive financial strategies to optimize your business performance and profitability"
      description="Our financial planning services provide expert guidance to help you make informed decisions, optimize resources, and achieve your business financial goals. We work closely with you to develop comprehensive strategies that align with your objectives and drive sustainable financial success."
      benefits={benefits}
      features={features}
      process={process}
      callToAction="Let's build a strong financial foundation for your business. Contact us to discuss how our financial planning services can help you achieve your financial objectives."
    />
  );
};

export default FinancialPlanning;

